import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { fetchMachineList } from 'state/global/machine/operation';
import * as selector from 'state/global/machine/selector';
import { STATE_PROP } from 'state/global/machine/util/constant';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import { PAGE_SIZE } from 'util/config/constant';
import { BaseTable } from '../../../UI/BaseTable';
import { renderColumns } from './util/render-columns';

export const MachineList = () => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.MY_MACHINE);
  const dispatch = useDispatch();
  const history = useHistory();

  const { machineListInfo } = useSelector((state) => ({
    machineListInfo: selector.selectMachineListInfo(state)
  }));

  const columns = useMemo(() => {
    return renderColumns(t);
  }, [t]);

  const [pagination, setPagination] = useState({
    token: '',
    limit: PAGE_SIZE,
    stateProp: STATE_PROP
  });

  const handlePageChange = (token) => {
    setPagination((currentPagination) => ({
      ...currentPagination,
      token
    }));
  };

  useEffect(() => {
    dispatch(
      fetchMachineList({
        limit: pagination.limit,
        token: pagination.token
      })
    );
  }, [dispatch, pagination.limit, pagination.token]);

  const tableProps = useMemo(
    () => ({
      columns,
      loading: machineListInfo.isLoading,
      dataSource: machineListInfo.data,
      rowKey: 'id',
      pagination: false,
      className: 'table-my-machines',
      onPageChange: handlePageChange,
      showHeader: false,
      onRow: (record) => ({
        onClick: () => {
          history.push(`/my-machines/${record.id}`);
        }
      })
    }),
    [columns, machineListInfo.data, machineListInfo.isLoading, history]
  );

  return (
    <div className="machine-list">
      <BaseTable {...tableProps} />
    </div>
  );
};
